import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography } from '@mui/material'
import moment from 'moment'
import PropTypes from 'prop-types'

import CarDataTable from '../CarDataTable'

function CarData({ digitalCertificate }) {
  const { basicData } = digitalCertificate
  const { t } = useTranslation()

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h3">{t('carData.title')}</Typography>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <CarDataTable
            data={[
              { label: t('carData.vin'), value: basicData.vin },
              {
                label: t('carData.registrationNumber'),
                value: basicData.registrationNumber,
              },
              { label: t('carData.mileage'), value: basicData.mileage },
            ]}
          />
        </Grid>
        <Grid item xs={6}>
          <CarDataTable
            data={[
              { label: t('carData.color'), value: basicData.color },
              {
                label: t('carData.manufacturingYear'),
                value: basicData.manufacturingYear,
              },
              {
                label: t('carData.firstRegistrationDate'),
                value: moment(basicData.firstRegistrationDate).format(
                  'DD-MM-YYYY',
                ),
              },
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

CarData.propTypes = {
  digitalCertificate: PropTypes.object,
}
CarData.defaultProps = {
  digitalCertificate: {},
}

export default CarData
